import React from 'react';
import PageWrapper from '../../components/pageWrapper/PageWrapper';

function LecturersPage() {
    return (
        // @ts-expect-error JS component has no TS types
        <PageWrapper>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'var(--color-text-secondary)', fontSize: '1.25rem'}}>
                בקרוב
            </div>
        </PageWrapper>
    );
}

export default LecturersPage;

// Full lecturer-management UI — kept commented for future restore
/*
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import * as css from './LecturersPage.css';
import PageWrapper from '../../components/pageWrapper/PageWrapper';
import LecturerCard from './lecturerCard/LecturerCard';
import PreviousLecturerCard from './previousLecturerCard/PreviousLecturerCard';
import AddLecturerFrame from './addLecturerFrame/AddLecturerFrame';
import AddLecturerPopup from '../components/manageLecturePopup/fields/AddLecturerPopup/AddLecturerPopup';
import useShow from '../../../hooks/useShow';
import {RootState} from '../../../redux/store.type';
import {TLecturer} from '../../../redux/timetable/timetable.type';
import {getLecturers, updateLecturer} from '../../../redux/timetable/timetableActions';

function LecturersPage() {
    const {t} = useTranslation('timetable');
    const eid       = useSelector((s: RootState) => s.event.eid);
    const lecturers = useSelector((s: RootState) => s.timetable.lecturers);
    const lectures  = useSelector((s: RootState) => s.timetable.lectures);
    const getLecturersXHR = useSelector((s: RootState) => s.timetable.getLecturersXHR);
    const addLecturerShow = useShow();
    const editShow = useShow();
    const [editLecturer, setEditLecturer] = useState<TLecturer | undefined>(undefined);

    useEffect(() => {
        if(eid && !getLecturersXHR) getLecturers().then();
    }, [eid, getLecturersXHR]);

    const eventLecturers    = lecturers.filter(l =>  l.inEvent);
    const previousLecturers = lecturers.filter(l => !l.inEvent);

    const assignedLids = new Set(
        Object.values(lectures).flat().flatMap(item => item.lecturers?.map(l => l.lid) ?? [])
    );

    return (
        // @ts-expect-error PageWrapper is a JS component without TS types
        <PageWrapper>
            <css.container>
                <css.sectionTitle>{t('manageLecturers')}</css.sectionTitle>

                <css.grid>
                    {eventLecturers.map(l => (
                        <LecturerCard
                            key={l.lid}
                            lecturer={l}
                            isAssignedToLecture={assignedLids.has(l.lid)}
                            onEdit={() => { setEditLecturer(l); editShow.open(); }}
                        />
                    ))}
                    <AddLecturerFrame onClick={addLecturerShow.open} />
                </css.grid>

                <css.divider />

                <css.previousHeader>
                    <css.sectionTitle>{t('previousLecturers')}</css.sectionTitle>
                </css.previousHeader>

                <css.previousGrid>
                    {previousLecturers.map(l => (
                        <PreviousLecturerCard
                            key={l.lid}
                            lecturer={l}
                            onAssign={() => updateLecturer(l.lid)}
                        />
                    ))}
                </css.previousGrid>
                {addLecturerShow.isOpen && <AddLecturerPopup show={addLecturerShow} />}
                {editShow.isOpen && <AddLecturerPopup show={editShow} lecturer={editLecturer} />}
            </css.container>
        </PageWrapper>
    );
}

export default LecturersPage;
*/
